import { lazyModule } from './lazyFunctions';
import { createLazyComponent } from 'owa-bundling';

export const AppRibbon = createLazyComponent(lazyModule, m => m.AppRibbon);

export type { AppRibbonProps } from './AppRibbon';
